const isMobile = window.innerWidth <= 719;
let visibleCount = isMobile ? 4 : 8;
const chunkSize = isMobile ? 4 : 8;

document.addEventListener("DOMContentLoaded", () => {
    const slides = document.querySelectorAll('.multi-column__grid-publication-item');
    slides.forEach((slide, index) => {
        slide.style.display = index < visibleCount ? '' : 'none';
    });
});

document.addEventListener('click', function (event) {
    const dropdown = document.querySelector('.custom-multiselect');
    if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('open');
    }
});

function toggleDropdown(e) {
    e.preventDefault();
    document.querySelector('.custom-multiselect').classList.toggle('open');
}

function toggleAllTags(selectAllCheckbox) {
    const checkboxes = document.querySelectorAll('.tag-checkbox');
    checkboxes.forEach(cb => cb.checked = selectAllCheckbox.checked);
    filterByTags();
}

function filterByTags() {
    const selectedTags = getCheckedTags();
    const showAll = selectedTags.includes('all') || selectedTags.length === 0;
    const slides = document.querySelectorAll('.multi-column__grid-publication-item');
    const readMoreWrapper = document.querySelector('.read-more-wrapper');
    let totalVisible = 0;

    slides.forEach(slide => {
        const card = slide.querySelector('.publications-card');
        if (!card) return;

        const tags = card.dataset.tags.split(',').map(tag => tag.trim());
        const isVisible = showAll || selectedTags.some(tag => tags.includes(tag));

        if (isVisible) {
            slide.style.display = totalVisible < chunkSize ? '' : 'none';
            totalVisible++;
        } else {
            slide.style.display = 'none';
        }
    });

    const toggleBtn = document.querySelector('.multiselect-toggle');
    if (showAll) {
        toggleBtn.innerHTML = `Select a Health Category <span class="arrow">▾</span>`;
    } else {
        const label = selectedTags.join(', ');
        toggleBtn.innerHTML = `${label} <span class="arrow">▾</span>`;
    }

    if (readMoreWrapper) {
        readMoreWrapper.style.display = totalVisible > chunkSize ? 'block' : 'none';
    }
}

function showMore() {
    const selectedTags = getCheckedTags();
    const showAll = selectedTags.includes('all') || selectedTags.length === 0;
    const slides = document.querySelectorAll('.multi-column__grid-publication-item');
    const matchingSlides = [];

    slides.forEach(slide => {
        const card = slide.querySelector('.publications-card');
        if (!card) return;

        const tags = card.dataset.tags.split(',').map(tag => tag.trim());
        const isMatch = showAll || selectedTags.some(tag => tags.includes(tag));

        if (isMatch) matchingSlides.push(slide);
    });

    let currentlyVisible = matchingSlides.filter(slide => slide.style.display !== 'none').length;

    const nextVisible = Math.min(currentlyVisible + chunkSize, matchingSlides.length);

    for (let i = currentlyVisible; i < nextVisible; i++) {
        matchingSlides[i].style.display = '';
    }

    // const offset = matchingSlides[currentlyVisible].getBoundingClientRect().top + window.pageYOffset - 180;
    // window.scrollTo({ top: offset, behavior: 'smooth' });

    const readMoreWrapper = document.querySelector('.read-more-wrapper');
    if (nextVisible >= matchingSlides.length && readMoreWrapper) {
        readMoreWrapper.style.display = 'none';
    }
}

function getCheckedTags() {
    return Array.from(document.querySelectorAll('.tag-checkbox:checked'))
        .map(input => input.value);
}